import { ChartMark, WidgetKind, type Report } from 'corso-admin-ui';
import {
  finalizedTrend,
  operationsWidgets,
  readyForReview,
} from '../claimItems';

export const operations = {
  key: 'operations',
  label: 'Operations',
  dataset: 'claimItems',
  timeFields: ['createdOn'],
  widgets: [
    {
      kind: WidgetKind.overTime,
      title: 'Requests over time',
      description: 'Warranty requests, and the line items on them',
      mark: ChartMark.line,
      metrics: ['claims', 'lineItems'],
    },
    ...operationsWidgets([
      finalizedTrend(
        'Time from claim submitted to resolved',
        'avgDaysClaimToResolved',
      ),
    ]),
    {
      kind: WidgetKind.ranking,
      title: 'Ready for review by requested resolution',
      dimension: 'requestedResolution',
      metric: 'items',
      filters: readyForReview,
    },
    {
      kind: WidgetKind.ranking,
      title: 'Resolution methods',
      dimension: 'resolution',
      metric: 'items',
    },
  ],
} as const satisfies Report;
